import { useFormikContext } from "formik";
import { useEffect } from "react";

export function isObjectEmpty(value) {
  return (
    Object.prototype.toString.call(value) === "[object Object]" &&
    JSON.stringify(value) === "{}"
  );
}

export function isOneDayPassed(date) {
  const now = new Date();
  const lastDate = new Date(date)
  const diff = now.getTime() - lastDate.getTime();
  const diffDays = diff / (1000 * 60 * 60 * 24);

  return diffDays >= 1;
}

export function formatObject(obj) {
  if (!obj) return "";

  return Object.keys(obj).filter(key => obj[key]).map(key => `${key}: ${obj[key]}`).join(' | ');
}

export function truncateText(text, maxLength) {
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + "...";
  }
  return text;
}

export function removeHTMLTags (string) {
  const regex = /(<([^>]+)>)/gi;
  const newString = string.replace(regex, "");

  return newString
}

export function getFieldErrorNames(formikErrors) {
  const transformObjectToDotNotation = (obj, prefix = "", result = []) => {
    Object.keys(obj).forEach((key) => {
      const value = obj[key];
      if (!value) return;

      const nextKey = prefix ? `${prefix}.${key}` : key;
      if (typeof value === "object") {
        transformObjectToDotNotation(value, nextKey, result);
      } else {
        result.push(nextKey);
      }
    });

    return result;
  };

  return transformObjectToDotNotation(formikErrors);
}

export function scrollToFieldError(errors) {
  const fieldErrorNames = getFieldErrorNames(errors);
  if (fieldErrorNames.length <= 0) return;

  const element = document.querySelector(`input[name='${fieldErrorNames[0]}']`);
  if (!element) return;

  element.scrollIntoView({ behavior: "smooth", block: "center" });
}

export const trimValues = (obj) => {
  const trimmedObj = { ...obj };
  Object.keys(trimmedObj).forEach(key => {
    if (typeof trimmedObj[key] === 'string') {
      trimmedObj[key] = trimmedObj[key].trim();
    }
  });
  return trimmedObj;
};

export const isNumericInput = (value) => {
  return /^\d*$/.test(value);
}

export const handleOpenLink = (url, target = "_blank") => {
  window.open(url, target);
};

export const FormErrorScroll = () => {
  const { isValid, submitCount, errors } = useFormikContext();

  useEffect(() => {
    if (isValid || submitCount === 0) return;
    scrollToFieldError(errors);
  }, [submitCount, isValid]);

  return null;
};

export const validateAmount = (amount) => {
  return /^[0-9]\d*(\.\d{1,4})?$/.test(amount);
};

export const toNumberInputString = (v) => {
  if (v === null || v === undefined || v === "") return "";
  const s = String(v).replace(/,/g, "").trim();
  const n = Number(s);
  if (Number.isNaN(n)) return "";
  return n.toFixed(2);
};
